<template>
  <div>
    <v-container class="fill-height">
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <h1
            class="text-h4 font-weight-bold primary--text d-flex align-center justify-center"
          >
            <v-icon size="x-large" color="primary" class="me-4"
              >mdi-cash-register</v-icon
            >
            <p class="text-h5 mt-4 font-weight-bold">
              Arqueo de caja, por favor indica los valores.
            </p>
          </h1>
        </v-col>
      </v-row>
    </v-container>
    <!-- {{ cajaId }} / {{ authStore.user.turno }} -->
    <CajaForm
      v-if="cajaId"
      :itemId="cajaId"
      @saved="handleSaved"
      arqueo="true"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCajaStore } from '@/stores/cajaStore'
import CajaForm from '@/components/cajas/CajaForm.vue'
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'
const router = useRouter()
const emit = defineEmits(['handleCajaInitialized'])

const cajaStore = useCajaStore()
const loading = ref(true)
const cajaId = ref(null)
const authStore = useAuthStore()

onMounted(async () => {
  try {
    console.log('Buscamos lastCaja')
    const lastCaja = await cajaStore.getLastCaja()
    if (lastCaja) {
      cajaId.value = lastCaja.id
      // lastCaja.turno = 'A'
    }
  } catch (error) {
    console.error('Error al inicializar caja:', error)
  } finally {
    loading.value = false
  }
})

const handleSaved = (responseCaja = null) => {
  console.log('handleSaved', responseCaja)
  if (responseCaja && responseCaja.turno) {
    authStore.updateTurnoFromIdentity(responseCaja.turno)
  }
  router.push('/caja/dashboard') // Redirige a la página principal después del login
  emit('handleCajaInitialized')
}
</script>
